import type {
  ChallengeActivity,
  Review,
} from "@/services/api/odin/activities/challenge/study-session/update"
import { MultipleChoiceQuestion } from "./multiple-choise-question"

interface ChallangeQuestionsProps {
  isLoading: boolean
  activity: ChallengeActivity
  displayReview: boolean
  review: Review
  onClickSendAnswer: (correctAnswer: number) => void
  onClickNextQuestion: () => void
}

export default function ChallangeQuestions({
  isLoading,
  review,
  displayReview,
  activity,
  onClickSendAnswer,
  onClickNextQuestion,
}: ChallangeQuestionsProps) {
  return (
    <div className="flex w-full items-center justify-center">
      <div className="w-full max-w-4xl">
        <div className="mb-8 text-lg text-neutral-800">{activity.next.question}</div>
        <MultipleChoiceQuestion
          review={review}
          isLoading={isLoading}
          displayReview={displayReview}
          options={activity.next.options}
          onClickSendAnswer={onClickSendAnswer}
          onClickNextQuestion={onClickNextQuestion}
        />
      </div>
    </div>
  )
}
